/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * API specification of VisDefinitionsAPI
 *
 * @class VisDefinitionsAPISpec
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'visDefinitions API',
					events: {
						propagationInfo: {
							namespace: 'visdefinitions',
							info: {
								name: 'VisDefinitions'
							},
							callStack: {
								name: 'getFeature',
								params: ['VisDefinitions']
							}
						},
						actions: {
							refresh: {
								type: 'refresh',
								getEventName: () => {
									return 'all';
								},
								getUndoActions: () => [{ name: 'refresh' }]
							}
						}
					}
				};
			}
			return this.apiSpec;
		}
	}
	return APISpec;
});